<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-alert
        v-if="notFound"
        type="error"
        outlined
        class="mb-4"
      >
        Placa não encontrada.
      </v-alert>

      <!-- CONSULTA -->
      <v-card outlined class="mb-4">
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
        />

        <v-card-title>Consulta de Veículos</v-card-title>

        <v-card-text>
          <v-row align="center">
            <!-- PLACA -->
            <v-col cols="4" md="2">
              <v-text-field
                v-model="placa"
                label="Placa"
                outlined
                dense
                hide-details
                :disabled="loading"
                @input="onInput"
                @keydown="bloquearCaracterInvalido"
                @keyup.enter="buscar"
              />
            </v-col>

            <!-- BUSCAR -->
            <v-col cols="4" md="auto" class="d-flex align-center">
              <v-btn
                color="primary"
                depressed
                block
                :loading="loading"
                :disabled="loading || !placa"
                @click="buscar"
              >
                Buscar
              </v-btn>
            </v-col>

            <!-- LIMPAR -->
            <v-col cols="4" md="auto" class="d-flex align-center">
              <v-btn
                text
                color="primary"
                block
                :disabled="loading"
                @click="limpar"
              >
                Limpar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- PLACEHOLDER -->
      <v-card
        v-if="!veiculo && !loading && !notFound"
        outlined
        class="pa-6 text-center"
      >
        <span class="text--secondary">
          Busque uma placa para ver os dados do veículo.
        </span>
      </v-card>

      <!-- RESULTADO -->
      <template v-if="veiculo && !loading">

        <!-- DADOS DO VEÍCULO -->
        <v-card outlined class="mb-4">
          <v-card-title>Dados do Veículo</v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="3">
                <div class="label">Marca / Modelo</div>
                <div class="value">{{ veiculo.marcaModelo || '-' }}</div>
              </v-col>

              <v-col cols="12" md="3">
                <div class="label">Placa</div>
                <div class="value">{{ veiculo.placa || '-' }}</div>
              </v-col>

              <v-col cols="12" md="3">
                <div class="label">Ano de Fabricação</div>
                <div class="value">{{ veiculo.anoFabricacao || '-' }}</div>
              </v-col>

              <v-col cols="12" md="3">
                <div class="label">Ano do Modelo</div>
                <div class="value">{{ veiculo.anoModelo || '-' }}</div>
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col cols="12" md="6">
                <div class="label">Chassi</div>
                <div class="value">{{ veiculo.chassi || '-' }}</div>
              </v-col>

              <v-col cols="12" md="6">
                <div class="label">Renavam</div>
                <div class="value">{{ veiculo.renavam || '-' }}</div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card outlined>
          <v-card-title>Histórico do Veículo</v-card-title>

          <v-card-text>
            <v-data-table
              :headers="headersHistorico"
              :items="historico"
              dense
              hide-default-footer
              class="historico-table"
            >
              <template #item.cpfVereador="{ item }">
                {{ formatCpf(item.cpfVereador) }}
              </template>

              <template #item.nomeFantasiaCamara="{ item }">
                {{ item.camara?.nomeFantasia || '-' }}
              </template>

              <template #item.dataInicioVigencia="{ item }">
                {{ formatDate(item.dataInicioVigencia) }}
              </template>

              <template #item.dataFimVigencia="{ item }">
                {{ formatDate(item.dataFimVigencia) }}
              </template>

              <template #item.ativo="{ item }">
                <v-chip
                  small
                  dark
                  :color="toBool(item.ativo) ? 'green' : 'red'"
                >
                  {{ toBool(item.ativo) ? 'Ativo' : 'Inativo' }}
                </v-chip>
              </template>

              <template #no-data>
                <div>Nenhum histórico encontrado.</div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

      </template>
    </v-container>
  </section>
</template>

<script>
import cpvService from '@/services/cpv/cpv.service';

export default {
  name: 'cpvVeiculos',

  data: () => ({
    placa: '',
    loading: false,
    veiculo: null,
    historico: [],
    notFound: false,

    headersHistorico: [
      { text: 'Câmara', value: 'nomeFantasiaCamara', align: 'center' },
      { text: 'CPF Vereador(a)', value: 'cpfVereador', align: 'center' },
      { text: 'Nome Vereador(a)', value: 'nomeVereador', align: 'center' },
      { text: 'Início Vigência', value: 'dataInicioVigencia', align: 'center' },
      { text: 'Fim Vigência', value: 'dataFimVigencia', align: 'center' },
      { text: 'Situação', value: 'ativo', align: 'center' },
    ],
  }),

  methods: {
    bloquearCaracterInvalido(e) {
      const permitidos = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
      if (permitidos.includes(e.key)) return;
      if (!/^[a-zA-Z0-9]$/.test(e.key)) e.preventDefault();
      if (this.placa.length >= 7) e.preventDefault();
    },
    onInput() {
      this.placa = (this.placa || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .slice(0, 7);

      this.erro = '';
      this.alertaLicenciamento = null;
      this.resetVeiculo();

      if (this.placa.length === 7) {
        this.buscar();
      }
    },
    buscar() {
      const plate = (this.placa || '').toUpperCase().trim();
      if (!plate) return;

      this.loading = true;
      this.veiculo = null;
      this.historico = [];
      this.notFound = false;

      cpvService.getVehiclebyPlate(plate)
        .subscribe({
          next: res => {
            const result = res?.result || null;

            if (!result) {
              this.notFound = true;
              this.veiculo = null;
              this.historico = [];
              return;
            }

            this.veiculo = {
              placa: result.placa,
              marcaModelo: result.marcaModelo,
              anoFabricacao: result.anoFabricacao,
              anoModelo: result.anoModelo,
              chassi: result.chassi,
              renavam: result.renavam,
            };

            this.historico = Array.isArray(result.historicoVeiculoVereadorResponseList)
              ? result.historicoVeiculoVereadorResponseList
              : [];
          },
          error: () => {
            this.notFound = true;
            this.loading = false;
          },
          complete: () => {
            this.loading = false;
          },
        });
    },

    limpar() {
      if (this.loading) return;
      this.placa = '';
      this.veiculo = null;
      this.historico = [];
      this.notFound = false;
    },

    toBool(v) {
      if (typeof v === 'boolean') return v;
      if (typeof v === 'number') return v === 1;
      if (typeof v === 'string') {
        const s = v.trim().toLowerCase();
        if (s === 'true' || s === '1') return true;
        if (s === 'false' || s === '0') return false;
      }
      return false;
    },

    formatCpf(cpf) {
      if (!cpf) return '-';
      const digits = String(cpf).replace(/\D/g, '').padStart(11, '0').slice(0, 11);
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    },

    formatDate(date) {
      if (!date) return '-';
      const [y, m, d] = String(date).split('-');
      if (!y || !m || !d) return '-';
      return `${d}/${m}/${y}`;
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 12px;
  color: #666;
}
.value {
  font-size: 14px;
  font-weight: 500;
}
.historico-table ::v-deep th {
  font-size: 12px;
  font-weight: 600;
}
.historico-table ::v-deep td {
  font-size: 12px;
}
</style>
